import React from 'react';
import theme from '@clad-ui/theme';
import { styled } from '@linaria/react';
const {
  colors
} = theme;
const InputClearIcon = () => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width="1em" height="1em" fill="none">
    <g fill="none" fillRule="evenodd">
      <circle fill={colors.textLighter} cx={6} cy={6} r={6} />
      <path d="M3.863 3.863l4.275 4.275m-.001-4.275L3.862 8.138" stroke="#FFF" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.6} />
    </g>
  </svg>;
const inputClasses = "i1dxj5p8";
export default inputClasses;
const inputFocusClasses = "i1kyc8bf";

/**
 *  @type {React.FC<any>}
 */
const _exp14 = /*#__PURE__*/() => ({
  containerWidth
}) => containerWidth;
const Container = /*#__PURE__*/styled('div')({
  name: "Container",
  class: "c3tmhmx",
  propsAsIs: false,
  vars: {
    "c3tmhmx-0": [_exp14()]
  }
});
const Paragraph = /*#__PURE__*/styled('p')({
  name: "Paragraph",
  class: "p1dmau4k",
  propsAsIs: false
});

/**
 *  @type {React.FC<any>}
 */
const InputWrapper = /*#__PURE__*/styled('div')({
  name: "InputWrapper",
  class: "i10f3ys1",
  propsAsIs: false
});

/**
 * @type {any}
 */
const TooltipWrapper = /*#__PURE__*/styled('div')({
  name: "TooltipWrapper",
  class: "t1peos0v",
  propsAsIs: false
});
export { inputFocusClasses, InputWrapper, Paragraph, Container, TooltipWrapper, InputClearIcon };

require("./Input.styles.linaria.module.css!=!../../../../../@linaria+webpack5-loader@4.1.17_webpack@5.95.0/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./Input.styles.js");